exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".size-selector[data-v-128f6d9b] {\n  width: 40px;\n  height: 40px;\n}\n.size-selector[data-v-128f6d9b]:hover, .size-selector[data-v-128f6d9b]:focus {\n    border-width: 2px;\n}\n.size-selector.active[data-v-128f6d9b] {\n    border-color: #828282;\n    border-width: 2px;\n    color: #828282;\n}\n.size-selector[data-v-128f6d9b]:disabled {\n    border-color: #e0e0e0;\n    color: #e0e0e0;\n    cursor: not-allowed;\n}\n.size-selector[data-v-128f6d9b]:disabled:hover, .size-selector[data-v-128f6d9b]:disabled:after {\n      border-width: 1px;\n}\n", ""]);

// exports
